import { JSX } from "react"
import GameView from "../../View/GameView"

export default function DailyGame(): JSX.Element {
  return (
    <GameView
      daily={true}
      seed={new Date().toDateString().replaceAll(" ", "-")}
    />
  )
}
